module.exports = __webpack_public_path__ + "static/media/nasa2.958dbdf0.jpg";